import { render, staticRenderFns } from "./ModalCreateUserProfile.vue?vue&type=template&id=cfc3e50c&"
import script from "./ModalCreateUserProfile.vue?vue&type=script&lang=js&"
export * from "./ModalCreateUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports